"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    notification.classList.add("notification", type);
    notification.style.cssText = "top: ".concat(posTop, "px; right: ").concat(posRight, "px");
    // create card
    //
    var heading = document.createElement("h2");
    heading.classList.add("title");
    heading.textContent = title;
    // create heading
    //
    var descr = document.createElement("p");
    descr.style.whiteSpace = "pre-line";
    descr.textContent = description;
    // create description
    //
    notification.append(heading, descr);
    document.body.append(notification);
    setTimeout(function() {
        return notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.81a3f83e.js.map
